import { mathRodsLearnerText } from './localization.mjs';

// Native feedback strings are numeric catalog references. The host resolves them;
// the canvas and standalone workshop must never display an internal string ID.
export function feedbackTextForDisplay(detail, correct, language = 'en') {
  if (typeof detail?.feedbackText === 'string' && detail.feedbackText.trim()) return detail.feedbackText;
  return mathRodsLearnerText(correct ? (language === 'es' ? '¡Correcto!' : 'Correct!') : (language === 'es' ? 'Inténtalo de nuevo.' : 'Try again.'), language);
}

export function standaloneFeedbackAudio(detail) {
  return typeof detail?.feedbackAudio === 'string' && detail.feedbackAudio !== 'INHERITED' ? detail.feedbackAudio : '';
}
